<h1 mat-dialog-title>Discount</h1>

<mat-dialog-content>
    <div class="flex flex-col gap-y-6">
        <p class="max-w-sm">The value entered below will be subtracted from the tax inclusive total, i.e. after taxes
            have been applied.
        </p>
        <app-key-value-pair name="Total before discount"
            [value]="data.totalExDiscount | hlCurrency:data.docket.currency_code:data.docket.currency_rate | async"></app-key-value-pair>

        <mat-form-field class="w-full">
            <span matPrefix [appAddCurrencyPrefix]="data.docket.currency_code">%</span>
            <mat-label>Discount</mat-label>
            <input matInput [formControl]="discountControl" name="Discount" placeholder="Discount" required="true"
                type="number" />
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-button (click)="saveDiscount()" cdkFocusInitial>Save</button>
</mat-dialog-actions>